import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';


const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = useSelector(state => state.session.token); // Obtiene el token de la sesión

  return (
    <Route
      {...rest}
      render={props =>
        token ? ( // Verifica si el token está presente
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
